import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/images/logo.svg'


const _hoisted_1 = {
  class: "bg-cod-gray-950",
  "aria-labelledby": "footer-heading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", {
  id: "footer-heading",
  class: "sr-only"
}, " Footer ", -1)
const _hoisted_3 = { class: "mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32" }
const _hoisted_4 = { class: "xl:grid xl:grid-cols-3 xl:gap-8" }
const _hoisted_5 = { class: "space-y-8" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-7 w-auto",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-white text-2xl ml-4 font-quicksand font-bold" }, "Clique Social", -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<p class=\"text-sm leading-6 text-gray-300\"> Clique Social connects people through exceptional events, offering a user-friendly platform for seamless event discovery, management, and ticketing. Unite, create, and share unforgettable experiences with just a few clicks! </p><div class=\"flex space-x-6\"><a href=\"https://www.facebook.com/cliquesocial.bw\" target=\"_blank\" class=\"text-gray-500 hover:text-gray-400\"><span class=\"sr-only\">Facebook</span><svg class=\"h-6 w-6\" fill=\"currentColor\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path fill-rule=\"evenodd\" d=\"M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z\" clip-rule=\"evenodd\"></path></svg></a></div>", 2)
const _hoisted_10 = { class: "mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0" }
const _hoisted_11 = { class: "md:grid md:grid-cols-2 md:gap-8" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-semibold leading-6 text-white" }, " Plan Events ", -1)
const _hoisted_13 = {
  role: "list",
  class: "mt-6 space-y-4"
}
const _hoisted_14 = { class: "mt-10 md:mt-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-semibold leading-6 text-white" }, " Company ", -1)
const _hoisted_16 = {
  role: "list",
  class: "mt-6 space-y-4"
}
const _hoisted_17 = { class: "mt-10 xl:mt-0" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-semibold leading-6 text-white" }, " Subscribe to our newsletter ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm leading-6 text-gray-300" }, " The latest news, articles, and resources, sent to your inbox weekly. ", -1)
const _hoisted_20 = { class: "mt-4 sm:ml-4 sm:mt-0 sm:flex-shrink-0" }
const _hoisted_21 = {
  key: 0,
  class: "flex justify-center items-center"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "mt-16 border-t border-white/10 pt-8 sm:mt-20 lg:mt-24" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs leading-5 text-gray-400" }, " © 2023 Clique Social (PTY) LTD. All rights reserved. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner = _resolveComponent("spinner")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "-m-1.5 p-1.5 flex items-center"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          }),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _hoisted_12,
              _createElementVNode("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation.events, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.name
                  }, [
                    _createVNode(_component_router_link, {
                      to: item.link,
                      "active-class": "!text-blaze-orange-600",
                      class: "text-sm leading-6 text-gray-300 hover:text-white"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("ul", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation.legal, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.name
                  }, [
                    _createVNode(_component_router_link, {
                      to: item.link,
                      "active-class": "!text-blaze-orange-600",
                      class: "text-sm leading-6 text-gray-300 hover:text-white"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _hoisted_19,
            _createVNode(_component_FormKit, {
              type: "form",
              actions: false,
              id: "newsletter-subscription-form",
              onSubmit: _ctx.submitHandler,
              "form-class": "mt-6 sm:flex sm:max-w-md items-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FormKit, {
                  type: "text",
                  name: "email",
                  placeholder: "Enter your email",
                  validation: "required|email",
                  classes: {
                  outer: 'w-full w-full min-w-0 appearance-none',
                  inner: 'mt-0 mb-0',
                  input: 'rounded-md border-0 bg-white/5 px-3 py-1.5 text-base text-white shadow-sm ring-1 ring-inset ring-white/10 placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-blaze-orange-600 sm:text-sm sm:leading-6 xl:w-full'
                }
                }),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_FormKit, {
                    type: "submit",
                    label: "Send Message",
                    classes: {
                    outer: 'w-full',
                    input: 'w-full' },
                    disabled: _ctx.commsStore.loading
                  }, {
                    default: _withCtx(() => [
                      (_ctx.commsStore.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                            _createVNode(_component_spinner, {
                              size: 6,
                              color: 'blaze-orange-500'
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.commsStore.loadingMessage), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_22, "Subscribe"))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ])
        ])
      ]),
      _hoisted_23
    ])
  ]))
}